import addClass from '../../../general/class/addClass';
import hasAttr from '../../../general/attr/hasAttr';
import removeClass from '../../../general/class/removeClass';

import exLanguage from '../../../language';
import * as exElement from '../../../utils/element';

import type { Context } from '../types';

// ----------------------------------------------------------------------------

function single(ctx: Context): any {
    function start(): void {
        // Foreach Data
        for (const option of ctx.shared.state.data) {
            //
            if (option.hidden) {
                ctx.shared.config.placeholder = option.text;
                continue;
            }

            // If there is no value and text
            if (!option.value && !option.text) {
                continue;
            }

            // Create
            const itemCreate = create(option);
            ctx.shared.elements.listing.dropdown.appendChild(itemCreate.element);

            // Options Push
            ctx.shared.state.options.push({
                element: itemCreate.link,
                option: option,
            });
        }

        progress();
    }

    function create(element: HTMLOptionElement): Record<string, any> {
        const elements: Record<string, any> = {};

        // Create element (item)
        const elItem = exElement.create({
            tag: 'li',
        });
        elements.element = elItem;

        elItem.addEventListener('click', function (evt): any {
            // If there is disabled
            if (hasAttr(elLink, 'disabled')) {
                evt.stopPropagation();
            }
        });

        // ------------------------------------------------------------

        //
        const elLink = ctx.option.createItem(element);
        elItem.appendChild(elLink);
        elements.link = elLink;
        //
        elLink.addEventListener('click', function (this: any): any {
            const value = this.getAttribute('value');
            const text = this.text;

            // Foreach Options
            for (const { element } of ctx.option.getOptions()) {
                removeClass(element, 'selected active');
            }
            addClass(this, 'selected active');

            // Set input text
            ctx.text.setValue(text);

            // Set current value
            ctx.current.setValue(value);
        });

        // ------------------------------------------------------------

        // Return
        return elements;
    }

    // ----------------------------------------------------------------

    function progress(): void {
        let text: string = '';

        // Foreach Options
        for (const { option } of ctx.option.getOptions()) {
            // If there is selected
            if (option.selected) {
                text = option.text;
                break;
            }
        }

        // --------------------------------------------------------------------

        //
        const placeholder = ctx.shared.config.placeholder ?? 'select.no_selected';
        //
        ctx.text.setValue(text || exLanguage.line(placeholder));
    }

    // ----------------------------------------------------------------

    return {
        start,
        progress,
    };
}

// ----------------------------------------------------------------------------

export default single;
